module.exports = __webpack_public_path__ + "images/Chris_Frazier.jpg?v=ed6e248ea40daa2c8608833418e73c0f";